import * as React from "react";
const SvgFiRrCloudHailMixed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-hail-mixed_svg__a)">
      <path
        fill="#062147"
        d="M9.817 24q-.123 0-.244-.03a1 1 0 0 1-.727-1.212l1.5-6a.999.999 0 0 1 1.839-.286 1 1 0 0 1 .101.77l-1.5 6a1 1 0 0 1-.969.758m4.934-3q-.124 0-.244-.03a1 1 0 0 1-.727-1.212l1.5-6a.999.999 0 0 1 1.839-.286 1 1 0 0 1 .101.77l-1.5 6a1 1 0 0 1-.969.758m-8 0q-.123 0-.244-.03a1 1 0 0 1-.727-1.212l1.5-6a1 1 0 1 1 1.94.484l-1.5 6a1 1 0 0 1-.969.758m12.25-1.5a1 1 0 0 1-.386-1.923c4.967-2.006 4.217-9.47-1.032-10.472a3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.086 6.967a6.1 6.1 0 0 0 .024 2.18 3 3 0 0 1-.964 2.763 3.522 3.522 0 0 0 .411 5.5 1 1 0 0 1-1.114 1.662A5.537 5.537 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.89A7.945 7.945 0 0 1 8.5.139a8.05 8.05 0 0 1 8.735 4.438 1.03 1.03 0 0 0 .742.57c7.187 1.423 8.193 11.483 1.411 14.278A1 1 0 0 1 19 19.5M11 14a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-6 9A1 1 0 1 0 7 23a1 1 0 0 0-2 0m8 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-hail-mixed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudHailMixed;
